//字母、数字、下划线
export function validOrd (ord) {
  const reg = /^\w+$/
  //const reg =/^[a-zA-Z0-9]+_+[\w]*[a-zA-Z0-9]+$/
  return reg.test(ord)
}

/**
 *手机
 * @param {*} phone
 */

export function validatePhone (phone) {
  // const reg = /^([0-9-]{1,18})$/;
  const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
  
  return reg.test(phone)
}

/**
 * 身份证号码验证
 * @param {string} id
 * @returns {Boolean}
 */
 export function isIdCard (id) {
  const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/;
  return reg.test(id)
}

/**
 * 6-20位，字母+数字组合,至少包含一个数字。一个字母  
 * @param {string} password
 * @returns {Boolean}
 */
export function validatePassword (password) {
   const reg=/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{6,20}$/;
  //const reg=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z0-9]{6,20}$/
  return reg.test(password)
}

/**
 * 6-20位，字母+数字组合,至少包含一个数字  ---登录密码
 * @param {string} password
 * @returns {Boolean}
 */
 export function validateLoginPassword (password) {
  const reg=/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{6,20}$/;
  return reg.test(password)
}

/**
 * 手机号中间隐藏
 * @param {*} tel
 * @returns
 */
export function phoneHide (tel) {
  tel = '' + tel
  var reg = /(\d{3})\d{4}(\d{4})/
  return tel.replace(reg, '$1****$2')
}

/**
 * 只能字母数字组合---   统一社会信用代码
 * @param {string} str
 * @returns {Boolean}
 */
export function isNumCap (str) {
  const reg = /^[a-z\d]+$/i
  return reg.test(str)
}

/**
 * 身份证号码验证id
 * @param {string} id
 * @returns {Boolean}
 */
export function getCardTypeNumber (id) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(id)
}


/**
 * 凭证金额验证
 * @param {string} id
 * @returns {Boolean}
 */
export function getAmountNumber (id) {
  const reg = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,9}\.\d{0,2}$|^[1-9]\d{0,9}$/
  return reg.test(id)
}
/**
 * 数字6位
 * @param {string} id
 * @returns {Boolean}
 */
export function getNumberSixDigits (id) {
  const reg = /\b\d{6}\b/
  return reg.test(id)
}

/**
 * 数字12位
 * @param {string} id
 * @returns {Boolean}
 */
 export function getNumberDigits (id) {
  const reg = /\b\d{12}\b/
  return reg.test(id)
}


/**
 *
 * @param {*} phone
 * 手机必须11位，1开头
 */

 export function validatePhoneNo (phone) {
  const reg = /^1[0-9]{10}$/
  return reg.test(phone)
}

/**
 *
 * @param {*} email
 * 邮箱验证
 */

 export function validateEmail (email) {
  const reg = /^[\u4e00-\u9fa5a-zA-Z\d]+([-_.][\u4e00-\u9fa5A-Za-z\d]+)*@([\u4e00-\u9fa5A-Za-z\d]+[-.]){1,2}[\u4e00-\u9fa5A-Za-z\d]{2,5}$/
  return reg.test(email)
}

/**
 *
 * @param {*} 
 * 统一社会信用代码
 */

 export function validateCode (code) {
  // const reg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
  // return reg.test(code)
  return CheckSocialCreditCode(code);
}

function CheckSocialCreditCode(Code){
  var patrn = /^[0-9A-Z]+$/; //18位校验及大写校验
  if ((Code.length != 18) || (patrn.test(Code) == false)) {
      return false;
  }else{
      var Ancode; //统一社会信用代码的每一个值
      var Ancodevalue; //统一社会信用代码每一个值的权重 
      var total = 0;
      var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]; //加权因子 
      var str = '0123456789ABCDEFGHJKLMNPQRTUWXY'; //不用I、O、S、V、Z 
      for (var i = 0; i < Code.length - 1; i++){
          Ancode = Code.substring(i, i + 1);
          Ancodevalue = str.indexOf(Ancode);
          total = total + Ancodevalue * weightedfactors[i]; //权重与加权因子相乘之和 
          
      }
      var logiccheckcode = 31 - total % 31;
      if (logiccheckcode == 31){
          logiccheckcode = 0;
      }
      var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
      var Array_Str = Str.split(',');
      logiccheckcode = Array_Str[logiccheckcode];
      var checkcode = Code.substring(17, 18);
      if (logiccheckcode != checkcode){
          return false;
      }
      return true;
  }
}

/**
 * 
 * @param {*} code 
 * 中文、英文、数字但不包括下划线等符号
 */
 export function validateChineseLetterNumber (code) {
  const reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
  return reg.test(code)
}

/**
 *
 * @param {*} 
 * 字母或者中文
 */

 export function validateChineseLetter (code) {
  const reg = /^[\u4e00-\u9fa5-Za-z]$/
  return reg.test(code)
}
/**
 *
 * @param {*} 
 * 中文
 */

 export function validateChinese (code) {
  const reg = /^[\u4e00-\u9fa5]{0,}$/
  return reg.test(code)
}

/**
 *
 * @param {*} 
 * 数字
 */

 export function validateNumber(code) {
  const reg = /^[0-9]*$/
  return reg.test(code);
}

/**
 *
 * @param {*} 
 * 固定电话
 */

 export function validateTelephone(code) {
  const reg = /^\d{3}-\d{7,8}$|^\d{4}-\d{7,8}$/;
  return reg.test(code)
}

/**
 *
 * @param {*} 
 * 金额
 */

 export function validateAmount(code) {
  const reg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{2}$)/;
  return reg.test(code)
}




